// Copyright ©️ 2026 eVolve MEP, LLC

import type * as THREE from 'three';

import {
  AngleGeometry,
  type AngleGeometryOpts,
} from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/Labels/AngleGeometry';
import {
  DimensionLabel,
  type DimensionLabelOpts,
} from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/Labels/DimensionLabel';

export type AngleLabelOpts = AngleGeometryOpts & DimensionLabelOpts;

export class AngleLabel extends DimensionLabel {
  declare geometry: AngleGeometry;

  constructor({ center, radius, startAngle, endAngle, rotation, ...dimensionLabelOpts }: AngleLabelOpts) {
    super((name) => new AngleGeometry(name, { center, radius, startAngle, endAngle, rotation }), dimensionLabelOpts);
  }

  getAnchorWorldPoints(): THREE.Vector3[] {
    return [this.geometry.localToWorld(this.geometry.arcMidPointLocal.clone())];
  }

  formatValue(value: number) {
    return `${value.toLocaleString()}°`;
  }
}
